import React from 'react';
import { connect } from 'react-redux';

import { Button } from '@eb/eds-button';
import { gettext } from '@eb/i18n';

import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
} from '../actions/search';

import './ExpandDedupedEventCTA.scss';

const ExpandDedupedEventCTA = (props) => {
    const handleExpandClick = () => {
        props.handleApplyFilter({
            hash: props.dedup.hash,
        });
    };

    const resultCount = props.dedup.count;
    const eventName = props.name;
    const copy = gettext('View %(resultCount)s similar results', {
        resultCount,
        eventName,
    });

    return (
        <div className="expand-dedupe-event-cta eds-align--center eds-l-pad-top-2">
            <Button
                style="link"
                onClick={handleExpandClick}
                __containerClassName="eds-l-pad-vert-1"
            >
                {copy}
            </Button>
        </div>
    );
};

const _mapStateToProps = (state) => {
    const experiments = state.app.experiments;
    const isStaff = state.user.isStaff;
    const experimentOverride = state.admin.experimentOverride;
    let variant;

    // Assume that if we have dupes then we are in a dupe experiment,
    // since the experiment name will change.
    if (experiments) {
        variant = Object.values(experiments)[0];
    }

    // Admin debug tool
    if (isStaff && experimentOverride) {
        variant = experimentOverride.variant;
    }

    return {
        variant,
    };
};

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(ExpandDedupedEventCTA);
